import PropTypes from 'prop-types'
import React from 'react'
import { map } from 'lodash'
import Tag from 'shared/components/tags/simpleTag'
import { getSuggestedSearchTerms } from 'shared/api/index'
import log from 'shared/util/log'
import { suggestedTermPingBackEvent } from 'shared/pingbacks/pingback-networking'

export default class SuggestedTerms extends React.PureComponent {
    state = { suggestedTerms: [] }

    static propTypes = {
        term: PropTypes.string.isRequired,
        css: PropTypes.object,
        isSticker: PropTypes.bool,
        isMobile: PropTypes.bool,
        searchResponseId: PropTypes.string,
    }

    async getTerms() {
        try {
            const { data: suggestedTerms } = await getSuggestedSearchTerms(this.props.term)
            this.setState({ suggestedTerms })
        } catch (e) {
            log.error(e)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.term !== this.props.term) {
            this.getTerms()
        }
    }

    componentDidMount() {
        this.getTerms()
    }

    render() {
        const { css, isSticker, searchResponseId, user } = this.props
        const terms = this.state.suggestedTerms
        const googleAnalytics = {
            category: 'Search',
            action: 'Related Tag Click	',
        }
        if (!terms.length) return <div className={css.sparseTermState} />
        return (
            <div className={css.termSuggestionContainer}>
                <div className={css.suggestions}>
                    {map(terms, (item, index) => (
                        <Tag
                            index={index}
                            name={item.name}
                            isSticker={isSticker}
                            key={index}
                            analytics={googleAnalytics}
                            pingbackAnalytics={{
                                component: 'SUGGESTED_SEARCH',
                                user: user,
                                data: [{ key: 'suggest_term', value: item.name }],
                                pingbackRequest: suggestedTermPingBackEvent,
                                searchResponseId: searchResponseId,
                                needToCheckForOverflow: true,
                                actionNames: {
                                    seen: 'SUGGESTED_SEARCH_SEEN',
                                    click: 'SUGGESTED_SEARCH_CLICK',
                                    hover: 'SUGGESTED_SEARCH_HOVER',
                                },
                            }}
                        />
                    ))}
                </div>
            </div>
        )
    }
}
